import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSlidesWideAdd"><Path d="M5.5 19.5V7.5H21.5V19.5H5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 16.5H2.5V4.5H18.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 13.5H13.5M13.5 13.5H16.5M13.5 13.5V10.5M13.5 13.5V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSlidesWideAdd;
